module.exports = __webpack_public_path__ + "img/201014_WS8B_1_Diagram.d262cce2.png";